import { css } from 'styled-components'

export const trendUpDownDataColorCss = css`
  &[data-trend='up'] {
    color: var(--up-9);
  }
  &[data-trend='down'] {
    color: var(--down-9);
  }
`
